import type { Area } from '~/types/area';
import type { EnergyTypes } from '~/types/new/energy';

export const coreAreaHelper = () => {
  const areaProductionUnit = (areaId: number | null | undefined) => {
    if (!areaId) return '--';

    const area = areaStore().getArea(areaId);
    return area?.production_unit?.symbol ?? '--';
  };

  const areaFabricationOrderUnit = (areaId: number | null | undefined) => {
    if (!areaId) return '--';

    const area = areaStore().getArea(areaId);
    return area?.fabrication_order_unit?.symbol ?? '--';
  };

  const availableArea = (areas: Area[], currentAreaId: number | undefined) => {
    const isAvailable = areas.some((area) => area.id === currentAreaId);
    if (isAvailable) return currentAreaId;
    const area = areas[0];
    return area?.id ?? null;
  };

  const availableEnergyType = (areaId: number, currentEnergyType: EnergyTypes) => {
    const area = areaStore().getArea(areaId);
    const isAvailable = area?.meters.some((meter) => meter.meter_type.energy_type === currentEnergyType);
    if (isAvailable) return currentEnergyType;
    const meter = area?.meters[0];
    return meter?.meter_type.energy_type ?? null;
  };

  return {
    areaProductionUnit,
    areaFabricationOrderUnit,
    availableArea,
    availableEnergyType,
  };
};
